import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useRef} from "react";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const FilterUpdates = ({actions, params, filters}) => {
    const [tC] = useTranslation("choices");
    const [dataSelects, setDataSelects] = useState({
        state: "",
        model: "",
        device_group: "",
        version: "",
    });
    const status = useRef(["n", "p", "e", "c", "o", "f", "u", "s"]);

    const onChange = (e) => {
        const {name, value} = e.target;

        if (value) {
            let toInteger = ["model_id", "device_group_id"];
            if (toInteger.includes(name)) {
                filters.current.chosen[name] = parseInt(value);
            } else {
                filters.current.chosen[name] = value;
            }
        } else {
            delete filters.current.chosen[name];
        }
        if (e.target.dataset.select) {
            let data = {...dataSelects};
            data[e.target.dataset.select] = value;
            setDataSelects(data);
        }

        filters.current.filter();
    };
    const onSearcher = (e) => {
        if (e.target.value === "") {
            filters.current.onChangeSearcher("");
        }
    };
    const handleSearch = (e) => {
        e.preventDefault();
        filters.current.onChangeSearcher(filters.current.searcher.ref.value);
    };

    const setSearcherRef = (element) => {
        if (filters) {
            filters.current.searcher.ref = element;
        }
    };

    return (
        <>
            <nav className="navbar navbar-expand actions-control w-100">
                <div className="d-flex m-2 ms-5 w-100">
                    <div className="navbar-brand me-5">{actions.title}</div>
                    <button
                        className="navbar-toggler "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent "
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbarSupportedContent" className="w-100">
                        <ul className="navbar-nav ">
                            <li className="nav-item me-2">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.send.onClick}
                                    disabled={actions.send.disabled}>
                                    <FontAwesomeIcon icon="paper-plane" />
                                </Button>
                            </li>
                            <li>
                                <div className="ms-3 mt-1">
                                    <label>Buscar</label>
                                    <div className="d-flex" role="search">
                                        <form className="d-flex ms-auto" role="search" onSubmit={handleSearch}>
                                            <input
                                                className="form-control border-end-0 rounded-end-0"
                                                type="search"
                                                name="searcher"
                                                placeholder="uuid, uid, dirección"
                                                aria-label="Search"
                                                ref={setSearcherRef}
                                                onInput={onSearcher}
                                            />
                                            <span
                                                className="input-group-text bg-white border-start-0 rounded-start-0"
                                                id="basic-addon1">
                                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                            </span>
                                        </form>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="ms-3 mt-1">
                                    <label htmlFor="filter-modes">Estado</label>
                                    <select
                                        className="form-select"
                                        id="filter-status"
                                        name="state"
                                        aria-label="Seleccionar Estado"
                                        data-select="state"
                                        value={dataSelects.state}
                                        onChange={onChange}>
                                        <option value="">Seleccionar a filtrar</option>
                                        {status.current.map((stuff, idx) => (
                                            <option key={idx} value={stuff}>
                                                {tC("firmwareState." + stuff)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </li>

                            <li>
                                {params.models.length > 1 ? (
                                    <div className="ms-3 mt-1">
                                        <label htmlFor="filter-modes">Modelo</label>
                                        <select
                                            className="form-select"
                                            id="filter-models"
                                            name="model_id"
                                            aria-label="Seleccionar Modos"
                                            data-select="model"
                                            value={dataSelects.model}
                                            onChange={onChange}>
                                            <option value="">Seleccionar filtrar</option>
                                            {params.models.map((stuff, idx) => (
                                                <option key={idx} value={stuff.id}>
                                                    {stuff.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </li>

                            <li>
                                {params.device_groups && params.device_groups.length > 0 ? (
                                    <div className="ms-3 mt-1">
                                        <label htmlFor="filter-device-groups">Grupo de Dispositivos</label>
                                        <select
                                            className="form-select"
                                            id="filter-device-groups"
                                            name="device_group_id"
                                            aria-label="Seleccionar Grupo"
                                            data-select="device_group"
                                            value={dataSelects.device_group}
                                            onChange={onChange}>
                                            <option value="">Seleccionar grupo</option>
                                            {params.device_groups.map((group, idx) => (
                                                <option key={idx} value={group.id}>
                                                    {group.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </li>

                            <li>
                                {params.container_groups && params.container_groups.length > 0 ? (
                                    <div className="ms-3 mt-1">
                                        <label htmlFor="filter-container-groups">Grupo de Contenedores</label>
                                        <select
                                            className="form-select"
                                            id="filter-container-groups"
                                            name="container_group_id"
                                            aria-label="Seleccionar Grupo"
                                            data-select="group"
                                            value={dataSelects.group}
                                            onChange={onChange}>
                                            <option value="">Seleccionar grupo</option>
                                            {params.container_groups.map((group, idx) => (
                                                <option key={idx} value={group.id}>
                                                    {group.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </li>

                            <li>
                                {params.versions && params.versions.length > 0 ? (
                                    <div className="ms-3 mt-1">
                                        <label htmlFor="filter-versions">Versión</label>
                                        <select
                                            className="form-select"
                                            id="filter-versions"
                                            name="version"
                                            aria-label="Seleccionar Versión"
                                            data-select="version"
                                            value={dataSelects.version}
                                            onChange={onChange}>
                                            <option value="">Seleccionar versión</option>
                                            {params.versions
                                                .filter((ver) => ver)
                                                .map((ver, idx) => (
                                                    <option key={idx} value={ver}>
                                                        {ver}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="row" style={{height: "90px"}}></div>
        </>
    );
};

export default FilterUpdates;
